import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../partials/Icon';

export default class Schools extends Component {
    render() {
        const school = this.props.data;

        return (
            <li>
                <Icon icon="school" color="pink" />
                <Link to={ `/superadmin/schools/edit/${ school.id }` }>{ school.name }</Link>

                <div className="sub-content">
                    {school.groups.length ? (
                        <ul>
                            { Object.keys(school.groups).map(function(key) {
                                return (
                                    <li key={ key }>
                                        <Icon icon="group" color="pink" />
                                        <Link to={ `/superadmin/groups/edit/${ school.groups[key].id }` }>{ school.groups[key].name }</Link>
                                    </li>
                                )
                            }) }
                        </ul>
                    ) : (
                        <span>Denna organisation har inga grupper.</span>
                    )}
                </div>
            </li>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/superadmin/Dashboard/School.js